import React, { useCallback, useEffect, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { mapDataForBackend } from './utils';
import { ResetFormData } from 'components/ResetPassword/interface';
import { setPasswordRequest, verifyToken } from 'utils/api/users';
import { Layouts, PageLayoutParams } from 'layouts/LayoutProvider';
import Template from 'screens/BrokerPortal/screens/Registration/components/Template/Template';
import { Modal, Box } from 'lmc-ui-library-rebrand';
import ResetPassword from 'components/ResetPassword/ResetPassword';
import { Loader } from 'components/Loader/Loader';
import ExpiredToken from 'screens/BrokerPortal/screens/Registration/screens/components/ExpiredToken';

interface RouteParams {
  id: string;
}

const ResetPasswordPage: React.FC<RouteComponentProps<RouteParams>> & PageLayoutParams = ({ match }) => {
  const [error, setError] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const { id } = match.params;
  const [validToken, setValidToken] = useState<boolean>(false);

  const history = useHistory();

  const handleSubmit = async (values: ResetFormData) => {
    try {
      const payload = mapDataForBackend(values, id);
      await setPasswordRequest(payload);
      setSubmitted(true);
    } catch (error) {
      setIsLoading(false);
      setShowModal(true);

      if (error.response.status === 500) {
        setError([`An unexpected error occurred (${error.response.status})`]);
      } else {
        setError(error.response.data.details);
      }
    }
  };

  const getData = useCallback(async () => {
    setIsLoading(true);
    const token = history.location.pathname.split('/')[3];
    try {
      const response = await verifyToken(token);
      setValidToken(response.status === 204);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setShowModal(true);

      if (error.response.status === 500) {
        setError([`An unexpected error occurred (${error.response.status})`]);
      } else {
        setError(error.response.data.details);
      }
    }
  }, [history.location.pathname]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <Template>
      <>
        {isLoading ? (
          <Loader />
        ) : validToken ? (
          <ResetPassword error={error} handleSubmit={handleSubmit} submitted={submitted} />
        ) : (
          <Box>
            <Box.Content>
              <ExpiredToken />
            </Box.Content>
          </Box>
        )}
        {showModal ? (
          <Modal showCloseBtn={true} isOpen={showModal} onClose={() => setShowModal(false)}>
            <Modal.Header title="Something went wrong!" mode="error" />
            <Modal.Content>{error && error.map((err: any) => <p>{err}</p>)}</Modal.Content>
          </Modal>
        ) : (
          undefined
        )}
      </>
    </Template>
  );
};

ResetPasswordPage.layout = Layouts.REGISTRATION;

export default ResetPasswordPage;
